// SMOOTH SCROLL TO ANCHOR ON LOAD
if(window.location.hash) {
    $('html, body').animate({
        scrollTop: $(window.location.hash).offset().top - 50
    }, 1000);
}

jQuery(function(){

	// SMOOTH SCROLL TO ANCHOR ON CLICK
	$(function() {
	  	$('a[href*="#"]:not([href="#"])').click(function() {
	    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - 50
				}, 1000);
				return false;
			}
	    }
	  	});
	});

	$('#hamburger').click(function(){
		$('#hamburger, nav#mobile').toggleClass('open');
	});

});